import { VerificationStatus } from "verdi-common/schemas/device/subSchemas/sproutVerification/generalSproutVerificationCheck";

/**
 * The possible states of a verification
 */
export enum VERIFICATION_STATE {
    SUCCESS,
    FAILED,
    INCOMPLETE,
    UNKNOWN,
}

/**
 * Maps vertitype's more complex VerificationStatus to our simplified VERIFICATION_STATE
 */
export const VERIFICATION_STATUS_TO_VERIFICATION_STATE: Record<VerificationStatus, VERIFICATION_STATE> = {
    successful: VERIFICATION_STATE.SUCCESS,
    pending: VERIFICATION_STATE.INCOMPLETE,
    error: VERIFICATION_STATE.FAILED,
    inconclusive: VERIFICATION_STATE.INCOMPLETE,
    warning: VERIFICATION_STATE.INCOMPLETE,
    catastrophic: VERIFICATION_STATE.FAILED,
};
